module.exports = __webpack_public_path__ + "static/media/1_A1_05.cee3071b.png";